import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import apiRequestType from "../../apiRequestType";

const updateNotification = (data) => {
  return apiRequestType(
    apiTypes.PUT,
    apiConstants.ADMIN.ENGAGEMENT_CENTER.UPDATE_NOTIFICATION,
    data
  );
};

export default updateNotification;
